const TAX_DETAILS_STATUS = {
  empty: "empty",
  pending: "pending",
  validated: "validated",
  unsupported: "unsupported",
  invalid: "invalid",
} as const;

/** `tax_id_validation.status` values the fee profile API returns. */
const TAX_ID_VALIDATION_STATUS = {
  pending: "PENDING",
  pendingReverification: "PENDING_REVERIFICATION",
  unverifiable: "UNVERIFIABLE",
  verified: "VERIFIED",
  notValid: "NOT_VALID",
  invalidFormat: "INVALID_FORMAT",
  unsupported: "UNSUPPORTED",
} as const;

/**
 * Banner status per validation result. A profile whose validation is missing
 * or reports a status not listed here reads as unsupported, so an unchecked
 * tax id is never presented as a validated one.
 */
const TAX_DETAILS_STATUS_BY_VALIDATION_STATUS = {
  [TAX_ID_VALIDATION_STATUS.pending]: TAX_DETAILS_STATUS.pending,
  [TAX_ID_VALIDATION_STATUS.pendingReverification]: TAX_DETAILS_STATUS.pending,
  [TAX_ID_VALIDATION_STATUS.unverifiable]: TAX_DETAILS_STATUS.pending,
  [TAX_ID_VALIDATION_STATUS.verified]: TAX_DETAILS_STATUS.validated,
  [TAX_ID_VALIDATION_STATUS.notValid]: TAX_DETAILS_STATUS.invalid,
  [TAX_ID_VALIDATION_STATUS.invalidFormat]: TAX_DETAILS_STATUS.invalid,
  [TAX_ID_VALIDATION_STATUS.unsupported]: TAX_DETAILS_STATUS.unsupported,
} as const;

/**
 * The single form path. Add vs update is inferred from the store, so the URL
 * only has to name which registration the form is for.
 */
const TAX_DETAILS_PATH = "/account/tax-details";

/** Query param naming the registration the form opens on. */
const TAX_DETAILS_SCOPE_PARAM = "scope";

/**
 * Which registration a form URL addresses. `federal` is the default, so
 * `?scope=federal` is accepted but never generated.
 */
const TAX_DETAILS_SCOPE = {
  federal: "federal",
  subregion: "subregion",
} as const;

/** The fee category that means "a tax the guest can register for". */
const TAX_DETAILS_FEE_CATEGORY = "VAT";

/**
 * The fee profile kind that holds a tax registration. Names the record's own
 * `type`, not the region's tax — a GST registration is still a `VAT` profile.
 */
const TAX_DETAILS_VAT_PROFILE_TYPE = "VAT";

/** Where the host-only add-ons confirmation lives. */
const TAX_DETAILS_ADD_ONS_PATH = "/hosting/add-ons";

/** Decimal places kept when rendering a VAT rate. */
const TAX_DETAILS_PERCENT_MAX_FRACTION_DIGITS = 2;

/**
 * Tax type used when the region names no tax for a slot. Renders as "Sales tax
 * details".
 */
const TAX_DETAILS_FALLBACK_TAX_TYPE = "other";

export {
  TAX_DETAILS_ADD_ONS_PATH,
  TAX_DETAILS_FALLBACK_TAX_TYPE,
  TAX_DETAILS_FEE_CATEGORY,
  TAX_DETAILS_PATH,
  TAX_DETAILS_PERCENT_MAX_FRACTION_DIGITS,
  TAX_DETAILS_SCOPE,
  TAX_DETAILS_SCOPE_PARAM,
  TAX_DETAILS_STATUS,
  TAX_DETAILS_STATUS_BY_VALIDATION_STATUS,
  TAX_DETAILS_VAT_PROFILE_TYPE,
  TAX_ID_VALIDATION_STATUS,
};
